export default {
  nganluongSignThresholdDate: new Date('2026-02-23T00:00:00+07:00').getTime(),

  statusCalendar: [
    { id: '0', text: 'Tất cả' },
    { id: 'APPLYING', text: 'Đang áp dụng' },
    { id: 'BLOCKED', text: 'Đã khoá' },
  ],
  configGender: [
    { id: 'MALE', text: 'Nam' },
    { id: 'FEMALE', text: 'Nữ' },
  ],
  levelEmployee: [
    { id: 0, text: '0' },
    { id: 1, text: '1' },
    { id: 2, text: '2' },
    { id: 3, text: '3' },
    { id: 4, text: '4' },
    { id: 5, text: '5' },
    { id: 6, text: '6' },
  ],
  contractPeriod: [
    { id: '2 Tháng', text: '2 tháng' },
    { id: '1 Năm', text: '1 năm' },
    { id: '2 Năm', text: '2 năm' },
    { id: '3 Năm', text: '3 năm' },
    { id: 'Vô Thời hạn', text: 'Không thời hạn' },
  ],

  optionUserStatus: [
    {
      id: 0,
      text: 'Tất cả',
    },
    {
      id: 'ACTIVE',
      text: 'Hoạt động',
    },
    {
      id: 'INACTIVE',
      text: 'Khóa',
    },
  ],
  optionUserstateConfig: [
    {
      id: 0,
      text: 'Tất cả',
    },
    {
      id: 'CREATE',
      text: 'Mới tạo',
    },
    {
      id: 'CONFIGURED',
      text: 'Đã cấu hình',
    },
  ],

  businessFields: [
    {
      code: 'BAN_LE',
      name: 'BÁN LẺ',
    },
    {
      code: 'BAO_HIEM',
      name: 'BẢO HIỂM',
    },
    {
      code: 'BAN_LE',
      name: 'BÁN LẺ',
    },
    {
      code: 'CO_KHI_XAY_DUNG',
      name: 'CƠ KHÍ - XÂY DỰNG',
    },
    {
      code: 'DICH_VU',
      name: 'DỊCH VỤ',
    },
    {
      code: 'DICH_VU_CONG_N.G.O',
      name: 'DỊCH VỤ CÔNG - N.G.O',
    },
    {
      code: 'DICH_VU_GIAI_TRI',
      name: 'DỊCH VỤ GIẢI TRÍ',
    },
    {
      code: 'DIEN_TU_CONG_NGHE',
      name: 'ĐIỆN TỬ - CÔNG NGHỆ',
    },
    {
      code: 'DU_LICH',
      name: 'DU LỊCH',
    },
    {
      code: 'DV_VAN_TAI',
      name: 'DV VẬN TẢI',
    },
    {
      code: 'FITNESS',
      name: 'YOGA - FITNESS',
    },
    {
      code: 'GIAO_DUC_DAO_TAO',
      name: 'GIÁO DỤC - ĐÀO TẠO',
    },
    {
      code: 'KHACH_SAN',
      name: 'KHÁCH SẠN - LƯU TRÚ',
    },
    {
      code: 'NHA_HANG',
      name: 'NHÀ HÀNG',
    },
    {
      code: 'NOI_THAT',
      name: 'NỘI THẤT',
    },
    {
      code: 'OTHER',
      name: 'KHÁC',
    },
    {
      code: 'OTO_XE_MAY_XE_DAP',
      name: 'Ô TÔ - XE MÁY',
    },
    {
      code: 'THAM_MY',
      name: 'SPA - THẨM MỸ',
    },
    {
      code: 'THOI_TRANG',
      name: 'THỜI TRANG',
    },
    {
      code: 'XANG_DAU_KHI_DOT',
      name: 'XĂNG DẦU - KHÍ ĐỐT',
    },
    {
      code: 'Y_TE',
      name: 'Y TẾ',
    },
    {
      code: 'LUU_NIEM',
      name: 'LƯU NIỆM',
    },
    {
      code: 'THUC_PHAM',
      name: 'THỰC PHẨM',
    },
    {
      code: 'DO_GIA_DUNG',
      name: 'ĐỒ GIA DỤNG',
    },
    {
      code: 'TAP_HOA',
      name: 'TẠP HÓA',
    },
    {
      code: 'MY_PHAM',
      name: 'MỸ PHẨM',
    },
  ],

  optionComphase: [
    { id: 'PROBATION', text: 'Thử việc' },
    { id: 'OFFICIAL', text: 'Chính thức' },
  ],

  listStatusContract: [
    {
      id: 'NEW',
      text: 'Mới tạo',
    },
    {
      id: 'WAITING_APPROVED_FEE',
      text: 'Chờ duyệt phí/Nội dung',
    },
    {
      id: 'APPROVED_FEE',
      text: 'Đã duyệt phí',
    },
    {
      id: 'LIQUIDATE',
      text: 'Thanh lý',
    },
    {
      id: 'EXPERTISE',
      text: 'Thẩm định - Chưa HĐ',
    },
    {
      id: 'EXPERTISE_COLLABORATOR',
      text: 'Đã thẩm định',
    },
    {
      id: 'SENT',
      text: 'Đã gửi MC',
    },
    {
      id: 'WAITING_SIGN',
      text: 'Chờ ký',
    },
    {
      id: 'SIGNING',
      text: 'Đang ký',
    },
    {
      id: 'SIGNED_MISS_IMAGE',
      text: 'Đã ký - Thiếu ảnh',
    },
    // {
    //   id: 'SIGNED',
    //   text: 'Đã ký'
    // },
    {
      id: 'SIGNED_WAITING_APPROVED',
      text: 'Đã ký - Chờ duyệt',
    },
    {
      id: 'APPROVED',
      text: 'Đã duyệt',
    },
    {
      id: 'REJECTED_SA',
      text: 'Bị từ chối SA',
    },
    {
      id: 'WAITING_APPROVED_MA',
      text: 'Chờ GDV duyệt',
    },
    {
      id: 'REJECTED_MC',
      text: 'Bị từ chối MC',
    },
    {
      id: 'REJECTED_MA',
      text: 'Bị từ chối MA',
    },
    {
      id: 'CANCELED',
      text: 'Đã hủy',
    },
    {
      id: 'EXPIRED',
      text: 'Hết hạn',
    },
    {
      id: 'ADDITIONAL',
      text: 'Cần bổ sung',
    },
    {
      id: 'PENDING_APPROVAL',
      text: 'Chờ MPOS thẩm định',
    },
    {
      id: 'PENDING_CONFIRM_APPROVAL',
      text: 'Chờ bank thẩm định',
    },
    {
      id: 'ACTIVE',
      text: 'MC đang hoạt động',
    },
  ],

  businessStateView: [
    'EXPERTISE',
    'EXPERTISE_COLLABORATOR',
    'PENDING_APPROVAL',
    'PENDING_CONFIRM_APPROVAL',
    'ACTIVE',
    'SIGNED_MISS_IMAGE',
    'SIGNED_WAITING_APPROVED',
    'APPROVED',
    'REJECTED_SA',
    'WAITING_APPROVED',
    'WAITING_APPROVED_MA',
    'ADDITIONAL',
    'LIQUIDATE',
  ],

  listStatusMC: [
    {
      id: 'NEW',
      text: 'Mới tạo',
    },
    {
      id: 'POTENTIAL',
      text: 'Tiềm năng',
    },
    {
      id: 'HAS_CONTRACT',
      text: 'Hợp đồng',
    },
    {
      id: 'APPROVAL',
      text: 'Thẩm định',
    },
    {
      id: 'HANDOVER',
      text: 'Bàn giao',
    },
    {
      id: 'DONE',
      text: 'Hoàn thành',
    },
    {
      id: 'REJECT',
      text: 'Từ chối',
    },
  ],

  formContract: [
    {
      id: false,
      text: 'Tất cả',
    },
    {
      id: 'E_CONTRACT',
      text: 'Hợp đồng điện tử',
    },
    {
      id: 'PAPER_CONTRACT',
      text: 'Hợp đồng giấy',
    },
  ],

  isDefaulValue: [
    {
      id: 0,
      text: 'Tất cả',
    },
    {
      id: false,
      text: 'Đề xuất',
    },
    {
      id: true,
      text: 'Mặc định',
    },
  ],

  customerType: [
    { id: false, text: 'Tất cả' },
    { id: 'COMPANY', text: 'Doanh nghiệp' },
    { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
    { id: 'INDIVIDUAL', text: 'Cá nhân' },
  ],

  confirmInvoice: [
    { id: 'CONFIRMED', text: 'Đã verify' },
    { id: 'UNCONFIRMED', text: 'Chưa verify' },
  ],

  transSale: ['SALE', 'AFTER_SALE', 'TELESALE', 'KEY_ACCOUNT'],

  saleLeader: ['SALE_MANAGER', 'SALE_LEADER', 'AFTER_SALE_LEADER', 'TELESALE_LEADER'],

  regionDirector: ['REGION_DIRECTOR'],

  superAdmin: ['SALE_DIRECTOR'],

  saleManager: [
    'SALE_LEADER',
    'SALE_MANAGER',
    'SALE_MANAGER',
    'AFTER_SALE_LEADER',
    'TELESALE_LEADER',
  ],

  listAfterSale: ['AFTER_SALE_LEADER', 'AFTER_SALE'],

  listRegionManager: ['REGION_DIRECTOR', 'SALE_DIRECTOR'],

  saleAdmin: ['SALE_ADMIN'],

  stateAddtionTimekepping: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'WAITING', text: 'Chờ duyệt' },
    { id: 'APRROVED', text: 'Đã duyệt' },
    { id: 'DENIED', text: 'Đã hủy' },
    { id: 'NOT_ACCEPT', text: 'Không xác nhận' },
    { id: 'ACCEPT', text: 'Xác nhận' },
  ],

  listTypeSale: [
    { id: 'REGION_DIRECTOR', text: 'Giám đốc vùng' },
    { id: 'SALE_DIRECTOR', text: 'Super Admin' },
    { id: 'SALE_MANAGER', text: 'Sale Manager' },
    { id: 'SALE_LEADER', text: 'Sale Leader' },
    { id: 'AFTER_SALE_LEADER', text: 'After Sale Leader' },
    { id: 'TELESALE_LEADER', text: 'Telesale Leader' },
    { id: 'SALE', text: 'Sale Man' },
    { id: 'SALE_ADMIN', text: 'Sale Admin' },
    { id: 'AFTER_SALE', text: 'After Sale' },
    { id: 'TELESALE', text: 'Telesale' },
    { id: 'KEY_ACCOUNT', text: 'Kế toán' },
  ],

  typeAppendix: [
    { id: 'CREDIT', text: 'Phụ lục trả góp' },
    { id: 'DEVICE', text: 'Phụ lục thiết bị' },
    { id: 'TRANS', text: 'Phụ lục phí giao dịch' },
    { id: 'MULTI_FUNCTIONAL', text: 'Phụ lục bổ sung' },
    { id: 'LIQUIDATE', text: 'Biên bản thanh lý' },
    { id: 'RECALL', text: 'Biên bản thu hồi' },
    { id: 'TRANSFER', text: 'Biên bản chuyển nhượng' },
    { id: 'PACKAGE', text: 'Phụ lục phần mềm' },
    { id: 'CASHBACK', text: 'Phụ lục cashback' },
    { id: 'LEND', text: 'Phụ lục cho mượn' },
    { id: 'MOTO', text: 'Phụ lục MOTO' },
    { id: 'AUTHBANK', text: 'Phụ lục ủy quyền ngân hàng' },
    { id: 'AUTHCONTRACT', text: 'Phụ lục ủy quyền ký hợp đồng' },
    { id: 'QR', text: 'Phụ lục QR quốc tế' },
    { id: 'HAND_OVER', text: 'Biên bản bàn giao' },
    { id: 'RENT', text: 'Phụ lục cho thuê' },
    { id: 'ONUS', text: 'Phụ lục ON-US' },
    { id: 'CHANGE', text: 'Phụ lục thay đổi thông tin' },
    { id: 'HOME_PAY_LATER', text: 'Phụ lục Home pay later' },
    { id: 'QR_CONNECTOR', text: 'Phụ lục QR Connector' },
    { id: 'LINK_CARD', text: 'Phụ lục Link Card' },
    { id: 'NGANLUONG_CONVERT', text: 'Hợp đồng (Ngân Lượng)' },
  ],
  mappingTypeAppendix: {
    DEVICE: 'PLTB',
    TRANS: 'PLPGD',
    CREDIT: 'PLTG',
    CASHBACK: 'PLCB',
    LIQUIDATE: 'BBTL',
    RECALL: 'BBTH',
    HAND_OVER: 'BBBG',
    PACKAGE: 'PLPM',
    QR: 'BBQR',
    LEND: 'LEND',
    ONUS: 'ONUS',
    CHANGE: 'CHANGE',
    RENT: 'RENT',
    HOME_PAY_LATER: 'HOME_PAY_LATER',
    QR_CONNECTOR: 'QR_CONNECTOR',
    LINK_CARD: 'LINK_CARD',
    NGANLUONG_CONVERT: 'NGANLUONG_CONVERT',
  },

  listReasonAppendix: [
    // Lý do bàn giao
    { id: 'DEVICE_LEND', text: 'Thiết bị cho MC mượn trong thời gian bảo hành' },
    { id: 'DEVICE_RETURNS_FREE', text: 'Thiết bị đổi trả miễn phí' },
    { id: 'DEVICE_RETURNS_FEE', text: 'Thiết bị đổi trả có phí' },
    { id: 'DEVICE_WARRANTY_SUCCESS', text: 'Thiết bị đã bảo hành thành công' },
    { id: 'DEVICE_WARRANTY_FAIL', text: 'Thiết bị đã bảo hành không thành công' },
    // Lý do thu hồi
    { id: 'DEVICE_ERROR', text: 'Thiết bị lỗi cần bảo hành' },
    { id: 'DEVICE_MC_RETURN', text: 'Thiết bị Merchant đã mua nhưng trả lại hoàn tiền' },
    {
      id: 'DEVICE_MC_CHANGE',
      text: 'Thiết bị Merchant đã mua nhưng trả lại để đổi sang thiết bị khác',
    },
    { id: 'DEVICE_SALE_LEND', text: 'Thiết bị cho mượn không đạt doanh số' },
    { id: 'DEVICE_MC_LEND', text: 'Thiết bị cho MC mượn' },
    // PLTB
    { id: 'PURCHASE', text: 'Mua mới' },
    { id: 'RENT', text: 'Cho thuê' },
    { id: 'LEND', text: 'Cho mượn' },
    { id: 'CASHBACK', text: 'CASHBACK' },
    { id: 'TBTL_CN', text: 'TBTL_CN' },
    // new
    { id: 'EXPORT_SELL', text: 'Xuất bán' },
    { id: 'EXPORT_TRANSFER', text: 'Xuất điều chuyển' },
    { id: 'EXPORT_LEND', text: 'Xuất thiết bị cho mượn' },
    { id: 'EXPORT_RETURNS', text: 'Xuất thiết bị đổi trả' },
    { id: 'EXPORT_WARRANTY', text: 'Xuất thiết bị đã bảo hành' },
    { id: 'EXPORT_RENT', text: 'Xuất thiết bị cho thuê' },
  ],

  businessRegistrationStates: [
    { id: 'NEW', text: 'Chưa cung cấp' },
    { id: 'ADDED', text: 'Đã cung cấp' },
    { id: 'APPROVED', text: 'Đã duyệt' },
    { id: 'REJECTED', text: 'Từ chối' },
    { id: 'BANK_REJECTED', text: 'Bank từ chối' },
    { id: 'SUSPENDED', text: 'Đã khóa' },
  ],

  statusCashback: [
    {
      id: 'NO_CASHBACK',
      text: 'Không Cashback',
    },
    {
      id: 'CASHBACK',
      text: 'Cashback',
    },
  ],
  mposVolumeNotes: [
    {
      id: 'VOLUME_GT_1B',
      text: 'CÓ DOANH SỐ >1 tỷ',
    },
    {
      id: 'VOLUME_GT_100M_LT_500M',
      text: 'CÓ DOANH SỐ >100tr ĐẾN 500tr',
    },
    {
      id: 'VOLUME_GT_100T_LT_5M',
      text: 'CÓ DOANH SỐ >100K ĐẾN < 5tr',
    },
    {
      id: 'VOLUME_GT_10M_LT_50M',
      text: 'CÓ DOANH SỐ >10TR ĐẾN <50TR',
    },
    {
      id: 'VOLUME_GT_500M_LT_1B',
      text: 'CÓ DOANH SỐ >500tr ĐẾN 1 tỷ',
    },
    {
      id: 'VOLUME_GT_50M_LT_100M',
      text: 'CÓ DOANH SỐ >50TR ĐẾN <100TR',
    },
    {
      id: 'VOLUME_GT_5M_LT_10M',
      text: 'CÓ DOANH SỐ >5TR ĐẾN <10tr',
    },
    {
      id: 'VOLUME_LT_100T',
      text: 'CÓ DOANH SỐ DƯỚI 100K',
    },
    {
      id: 'VOLUME_0',
      text: 'KHÔNG DOANH SỐ',
    },
  ],

  listReason: [
    // {
    //   id: 'FORGOT_ATTN',
    //   text: 'Quên chấm công'
    // },
    {
      id: 'FORGOT_ATTN_IN',
      text: 'Bổ sung Checkin',
    },
    {
      id: 'FORGOT_ATTN_OUT',
      text: 'Bổ sung Checkout',
    },
    {
      id: 'TIME_KEEPER_ERROR',
      text: 'Máy chấm công lỗi',
    },
    {
      id: 'COMPANY_WORK',
      text: 'NV mới ON chưa có tài khoản',
    },
  ],

  parameter_cell: {
    add_cy: 18000,
    add_cx: 36000,
    coefficient: 1000000,
  },

  optionPolygonCleanup: {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    label: 'gfgdfgfgf',
  },

  localeData: {
    direction: 'ltr',
    format: 'dd/mm/yyyy',
    separator: ' - ',
    applyLabel: 'Áp dụng',
    cancelLabel: 'Hủy bỏ',
    weekLabel: 'W',
    daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    monthNames: [
      'Tháng 1',
      'Tháng 2',
      'Tháng 3',
      'Tháng 4',
      'Tháng 5',
      'Tháng 6',
      'Tháng 7',
      'Tháng 8',
      'Tháng 9',
      'Tháng 10',
      'Tháng 11',
      'Tháng 12',
    ],
    firstDay: 0,
  },

  positionNexttech: { lat: 20.99491, lng: 105.86184 },
  positionNexttechBounds: {
    latitudeEnd: 21.014131588522183,
    latitudeStart: 20.974065080273675,
    longitudeEnd: 105.92338200083252,
    longitudeStart: 105.80158825388428,
  },

  satusOderForm: [
    { id: 'NEW', text: 'Mới tạo', bgColor: 'bg-primary' },
    { id: 'CONFIRMED', text: 'CN xác nhận', bgColor: 'bg-warning' },
    { id: 'CANCELED', text: 'Đã huỷ', bgColor: 'bg-danger' },
    { id: 'BRANCH_REJECTED', text: 'CN từ chối', bgColor: 'bg-danger' },
    { id: 'MNP_FULFILLED', text: 'Hoàn thành', bgColor: 'bg-success' },
    { id: 'MNP_REJECTED', text: 'MNP từ chối', bgColor: 'bg-danger' },
    { id: 'MNP_PROCESSING', text: 'MNP đang xử lý', bgColor: 'bg-warning' },
  ],

  listServiceTypes: {
    NEXT_SHOP: 'NextShop',
    NEXT_PHAR: 'NextPhar',
    NEXT_ORDER: 'NextOrder',
    OMI_SELL: 'Omisell',
    MY_SPA: 'MySpa',
    POS_APP: 'PosApp',
    NEXT_ACC: 'NextAcc',
    NEXT_CAM: 'NextCam',
    CNV_LOYALTY: 'CNV Loyalty',
    NEXT_HR: 'NextHR',
    MEGA_DOC: 'Megadoc',
    V_INVOICE: 'VInvoice',
  },

  listNameDevice: {
    SMART_POS: 'SmartPOS',
    PR_01: 'PR 01',
    PR_02: 'PR 02',
  },

  satusOderForm: [
    { id: 'NEW', text: 'Mới tạo', bgColor: 'bg-primary' },
    { id: 'CONFIRMED', text: 'CN xác nhận', bgColor: 'bg-warning' },
    { id: 'CANCELED', text: 'Đã huỷ', bgColor: 'bg-danger' },
    { id: 'BRANCH_REJECTED', text: 'CN từ chối', bgColor: 'bg-danger' },
    { id: 'MNP_FULFILLED', text: 'Hoàn thành', bgColor: 'bg-success' },
    { id: 'MNP_REJECTED', text: 'MNP từ chối', bgColor: 'bg-danger' },
    { id: 'MNP_PROCESSING', text: 'MNP đang xử lý', bgColor: 'bg-warning' },
  ],
  satusOderFormTransfer: [
    { id: 'NEW', text: 'Mới tạo', bgColor: 'bg-primary' },
    { id: 'MOVING', text: 'Đang chuyển', bgColor: 'bg-warning' },
    { id: 'CANCELED', text: 'Đã huỷ', bgColor: 'bg-danger' },
    { id: 'REJECT_IMPORT', text: 'Từ chối nhận', bgColor: 'bg-danger' },
    { id: 'SUCCESS', text: 'Hoàn thành', bgColor: 'bg-success' },
  ],
  dataUnit: [
    { id: 'DAY', text: 'Ngày' },
    { id: 'MONTH', text: 'Tháng' },
  ],

  dataWorkType: [
    { id: 'ALL', text: 'Tất cả' },
    { id: 'LEAD', text: 'Lead' },
    { id: 'POTENTIAL', text: 'KH Tiềm Năng' },
    { id: 'MERCHANT', text: 'Merchant' },
  ],
  dataLeadAction: [
    { id: 'ALL', text: 'Tất cả' },
    { id: 'MET', text: 'Gặp mặt tư vấn' },
    { id: 'CALLED', text: 'Gọi điện' },
    { id: 'SENT_MESS', text: 'Nhắn tin' },
    { id: 'SENT_MAIL', text: 'Gửi email' },
    { id: 'OTHER', text: 'Việc khác' },
  ],
  dataPeriod: [
    { id: 'ALL', text: 'Tất cả' },
    { id: true, text: 'Ưu tiên' },
    { id: false, text: 'Không ưu tiên' },
  ],

  dataStatusStaff: [
    {
      id: 'all',
      text: 'Tất cả',
    },
    {
      id: 'ACTIVE',
      text: 'Hoạt động',
    },
    {
      id: 'INACTIVE',
      text: 'Khoá',
    },
  ],

  certStatusOptions: [
    { id: 'VERIFIED', text: 'Đã chứng thực', color: 'success' },
    { id: 'UNVERIFIED', text: 'Chưa chứng thực', color: 'danger' },
  ],
  typeReceiveNoticeInvoice: [
    { id: 'COMPANY', text: 'Công ty', color: 'success' },
    { id: 'INDIVIDUAL', text: 'Cá nhân', color: 'danger' },
  ],

  statusOptionsAgentPartner: [
    { id: 'ACTIVE', text: 'Hoạt động', color: 'success' },
    { id: 'LOCKED', text: 'Khoá', color: 'danger' },
  ],

  listContractType: [
    { id: 'all', text: 'Tất cả' },
    { id: 'COMPANY', text: 'Doanh nghiệp' },
    { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
    { id: 'INDIVIDUAL', text: 'Cá nhân' },
  ],

  dataAgentGroup: [
    { id: '0', text: 'Tất cả' },
    { id: 'SAPO', text: 'SAPO' },
    { id: 'NEXTPAY', text: 'NEXTPAY' },
    { id: 'MSB', text: 'MSB' },
    { id: 'POSAPP', text: 'POSAPP' },
    { id: 'NEXTPAY_INDIVIDUAL', text: 'Nextpay Cá nhân' },
    { id: 'NEXTPAY_COMPANY', text: 'Nextpay doanh nghiệp' },
  ],

  sourceCreate: [
    { text: 'Direct Sales', id: 'SALES' },
    { text: 'Cộng tác viên', id: 'AGENCY' },
    { text: 'Marketing', id: 'MARKETING' },
    { id: 'AFTER_SALE', text: 'After sale' },
    { id: 'TELESALE', text: 'Telesale' },
    { id: 'PARTNER_TEAM', text: 'Team đối tác' },
    { id: 'OP_AFTER_SALE', text: 'Vận hành CSKH tạo' },
  ],
  listStatusProposal: [
    { text: 'Tất cả', id: '0' },
    { text: 'Mới tạo', id: 'PENDING', bgColor: 'badge badge-primary' },
    { text: 'Đã duyệt', id: 'APPROVED', bgColor: 'badge badge-success' },
    { text: 'Từ chối', id: 'REJECTED', bgColor: 'badge badge-danger' },
    { text: 'Đã hủy', id: 'CANCELLED', bgColor: 'badge badge-danger' },
  ],

  leadStatus: [
    { text: 'Tất cả', id: '0' },
    { text: 'Mới tạo', id: 'NEW' },
    { text: 'Chưa quan tâm', id: 'NO_CARE' },
    { text: 'Phù hợp', id: 'VERIFIED' },
    { text: 'Đã sử dụng dịch vụ', id: 'USED_SERVICE' },
    { text: 'Trùng thông tin', id: 'DUPLICATE' },
    { text: 'Thông tin sai', id: 'WRONG' },
    { text: 'Quá thời gian chăm sóc', id: 'EXPIRED_SUPPORT' },
  ],
  levelWarehouse: [
    { id: 'ALL', text: 'Tổng' },
    { id: 'AREA', text: 'Vùng' },
    { id: 'CITY', text: 'Tỉnh' },
    { id: 'EMPLOYEE', text: 'Nhân viên' },
  ],
  typeWarehouse: [
    { id: 'INVENTORY', text: 'Kho chung' },
    { id: 'AGENCY', text: 'Kho đại lý' },
    { id: 'WARRANTY', text: 'Kho bảo hành' },
    // { id: 'EMPLOYEE', text: 'Kho nhân viên' },
    { id: 'PARTNER', text: 'Kho đối tác' },
    { id: 'E_COMMERCE_WAREHOUSE', text: 'Kho thương mại điện tử' },
    { id: 'MC_SELF_ONBOARD', text: 'Mc tự kích hoạt' },
    { id: 'BANK', text: 'Kho bank' },
  ],
  levelWarehouseCreate: [
    { id: 'ALL', text: 'Tổng' },
    { id: 'AREA', text: 'Vùng' },
    { id: 'CITY', text: 'Tỉnh' },
  ],
  typeDevice: [
    { id: 'CARD_SWIPE_MACHINE', text: 'Máy quẹt thẻ' },
    { id: 'PRINTER', text: 'Máy in' },
    { id: 'PRINTING_PAPER', text: 'Giấy in' },
    { id: 'CAMERA', text: 'Camera' },
    { id: 'SELLING_MACHINE', text: 'Máy bán hàng' },
    { id: 'BARCODE_READER', text: 'Máy đọc BarCode' },
    { id: 'ACCESSORY', text: 'Linh kiện' },
    { id: 'OTHER', text: 'Khác' },
  ],
  statusCatDevice: [
    { id: 'ACTIVE', text: 'Đang hoạt động' },
    { id: 'LOCKED', text: 'Đã khoá' },
  ],
  unitDevice: [
    { id: 'PIECE', text: 'Chiếc' },
    { id: 'GEAR', text: 'Thùng' },
  ],
  typeImportWarehouse: [
    { id: 'IMPORT_ODD', text: 'Nhập thiết bị lẻ' },
    { id: 'IMPORT_FILE', text: 'Nhập theo file' },
  ],
  reasonHandOver: [
    {
      id: 'DEVICE_LEND',
      text: 'Thiết bị cho MC mượn trong thời gian bảo hành',
    },
    { id: 'DEVICE_RETURNS', text: 'Thiết bị đổi trả' },
    { id: 'DEVICE_RETURNS_FREE', text: 'Thiết bị đổi trả miễn phí' },
    { id: 'DEVICE_RETURNS_FEE', text: 'Thiết bị đổi trả có phí' },
    { id: 'DEVICE_WARRANTY_SUCCESS', text: 'Thiết bị đã bảo hành thành công' },
    { id: 'DEVICE_WARRANTY_FAIL', text: 'Thiết bị đã bảo hành không thành công' },
    { id: 'DEVICE_WARRANTY', text: 'Thiết bị đã bảo hành' },
  ],
  reasonImportWarehouse: [
    { id: 'NEW_PURCHASE', text: 'Mua mới' },
    { id: 'ENTER_REFUND', text: 'Nhập hoàn trả' },
    { id: 'ENTER_LIQUIDATE', text: 'Nhập Thanh lý - Chuyển nhượng' },
    { id: 'IMPORT_TRANSFER', text: 'Nhập điều chuyển' },
    { id: 'IMPORT_WARRANTY', text: 'Nhập bảo hành' },
    {
      id: 'IMPORT_MC_RETURN',
      text: 'Nhập thiết bị do MC trả lại có hoàn tiền',
    },
    { id: 'DEVICE_MC_CHANGE', text: 'Thiết bị do MC trả lại để đổi thiết bị' },
    {
      id: 'IMPORT_SALE_LEND',
      text: 'Nhập thiết bị cho mượn không đạt doanh số',
    },
    { id: 'IMPORT_MC_LEND', text: 'Nhập thiết bị cho MC mượn' },
    { id: 'IMPORT_BALANCE', text: 'Nhập điều chỉnh số lượng' },
    { id: 'EXPORT_BALANCE', text: 'Xuất điều chỉnh số lượng' },
    { id: 'IMPORT_DEALER_RECALL', text: 'Thu hồi thiết bị từ đại lý' },
  ],
  statusExportWarehouse: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'APPROVED', text: 'Đã duyệt' },
    { id: 'REJECTED', text: 'Từ chối duyệt' },
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'CANCELLED', text: 'Đã huỷ' },
  ],
  statusTranferAgent: [
    { id: 'NEW', text: 'Mới tạo', color: 'success' },
    { id: 'DONE', text: 'Đã thu tiền', color: 'success' },
    { id: 'PENDING_SA_APPROVAL', text: 'Chờ SA duyệt', color: 'primary' },
    { id: 'PENDING_SA_APPROVE', text: 'Chờ SA duyệt', color: 'primary' },
    { id: 'PENDING_ACCOUNTANT_APPROVAL', text: 'Chờ kế toán duyệt', color: 'primary' },
    { id: 'PENDING_ACCOUNTANT_APPROVE', text: 'Chờ kế toán duyệt', color: 'primary' },
    { id: 'CANCEL', text: 'Bị hủy', color: 'danger' },
    { id: 'SA_REJECTED', text: 'Bị SA từ chối', color: 'danger' },
    { id: 'ACCOUNTANT_REJECTED', text: 'Bị kế toán từ chối', color: 'danger' },
    { id: 'COLLECTED_MONEY', text: 'Đã thu tiền', color: 'success' },
  ],
  statusTranferAgentInvoice: [
    { id: 'NEW', text: 'Chưa tạo hóa đơn', color: 'primary' },
    { id: 'MANUAL', text: 'Đã tạo thủ công', color: 'success' },
    { id: 'AUTO', text: 'Đã tạo tự động', color: 'success' },
    { id: 'CANCEL', text: 'Bị hủy', color: 'danger' },
  ],
  statusWarehouse: [
    { id: 'NEW', text: 'Mới tạo', color: 'badge-primary' },
    { id: 'APPROVED', text: 'Đã duyệt', color: 'badge-success' },
    { id: 'REJECTED', text: 'Từ chối duyệt', color: 'badge-danger' },
    { id: 'MOVING', text: 'Đang chuyển', color: 'badge-warning' },
    { id: 'REJECT_IMPORT', text: 'Từ chối nhập', color: 'badge-danger' },
    { id: 'SUCCESS', text: 'Thành công', color: 'badge-success' },
    { id: 'CANCELLED', text: 'Đã huỷ', color: 'badge-danger' },
    { id: 'NOT_RECEIVED', text: 'Không nhận được hàng', color: 'badge-danger' },
  ],
  statusWarehouseAgency: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'APPROVED', text: 'Đã duyệt' },
    { id: 'REJECTED', text: 'Từ chối' },
    { id: 'CANCELLED', text: 'Đã huỷ' },
    { id: 'COMPLETED', text: 'Hoàn thành' },
    { id: 'WAIT_APPROVE', text: 'Chờ duyệt' },
  ],
  statusImportWarehouse: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'APPROVED', text: 'Đã duyệt' },
    { id: 'REJECTED', text: 'Từ chối duyệt' },
    { id: 'CANCELLED', text: 'Đã huỷ' },
  ],
  reasonReturn: [{ id: 'RETURN_E_COMMERCE', text: 'Hoàn hàng TMĐT' }],
  historyWarehouse: [
    { id: 'NEW', text: 'Tạo mới' },
    { id: 'APPROVED', text: 'Duyệt' },
    { id: 'MOVING', text: 'Xác nhận đã chuyển' },
    { id: 'REJECTED', text: 'Từ chối duyệt' },
    { id: 'REJECT_IMPORT', text: 'Từ chối nhận TB' },
    { id: 'SUCCESS', text: 'Xác nhận đã nhận' },
    { id: 'NOT_RECEIVED', text: 'Không nhận được hàng' },
  ],
  statusDevices: [
    { id: 'AVAILABILITY', text: 'Khả dụng' },
    { id: 'WAIT_IMPORT', text: 'Chờ nhập' },
    { id: 'WAIT_TRANSFER', text: 'Chờ chuyển' },
    { id: 'MOVING', text: 'Đang chuyển' },
    { id: 'WAITING_EXPORT', text: 'Tạo HĐ, chờ duyệt' },
    { id: 'EXPORTED', text: 'Xuất thành công' }, // bỏ khi search
    { id: 'WARRANTY', text: 'Chờ bảo hành' },
    { id: 'WARRANTING', text: 'Đang bảo hành' },
    { id: 'CANCELLED', text: 'Đã hủy' },
    { id: 'LOSS', text: 'Thất lạc' },
    { id: 'USED', text: 'Đã qua sử dụng' },
    { id: 'LENT', text: 'Xuất thành công' }, // bỏ khi search
    { id: 'LENT_WARRANTY', text: 'Xuất thành công' }, // bỏ khi search
    { id: 'EXPORT_RENT', text: 'Xuất thành công' }, // bỏ khi search
    { id: 'DONE', text: 'Xuất thành công' },
    { id: 'WAIT_USAGE_CHANGE', text: 'Chuyển test, chờ duyệt' },
    { id: 'WAIT_RETURN', text: 'Chờ hoàn' },
  ],
  statusRequestTicket: [
    { id: 'NEW', text: 'Chờ SA xác nhận', bgColor: 'badge-warning' },
    { id: 'SA_CONFIRMED', text: 'Chờ GĐV duyệt', bgColor: 'badge-info' },
    { id: 'SA_REJECTED', text: 'SA từ chối', bgColor: 'badge-danger' },
    { id: 'APPROVED', text: 'GĐV duyệt', bgColor: 'badge-success' },
    { id: 'REJECTED', text: 'GĐV từ chối', bgColor: 'badge-danger' },
    { id: 'CANCELLED', text: 'Đã hủy', bgColor: 'badge-secondary' },
  ],
  groupstatusDevices: [
    { id: 0, text: 'Tất cả' },
    { id: 'INVENTORY', text: 'Tồn kho' },
  ],
  stateDevices: [
    { id: 'ACTIVE', text: 'Hoạt động' },
    { id: 'ERROR', text: 'Bị lỗi' },
    { id: 'WARRANTY', text: 'Đang bảo hành' },
    { id: 'LOSS', text: 'Thất lạc' },
    { id: 'BROKEN_PART', text: 'Bị hỏng 1 phần' },
    { id: 'BROKEN_ALL', text: 'Bị hỏng hoàn toàn' },
  ],
  typeBill: [
    { id: 'IMPORT', text: 'Nhập kho' },
    { id: 'EXPORT', text: 'Xuất kho' },
    { id: 'TRANSFER', text: 'Điều chuyển' },
    { id: 'RECALL', text: 'Thu hồi' },
    { id: 'RETURN', text: 'Hoàn trả' },
    { id: 'USAGE_CHANGE', text: 'Thay đổi mục đích sử dụng' },
  ],
  statusBoxme: [
    { id: 212, text: 'Thiếu hàng', bgColor: 'badge badge-warning' },
    { id: 304, text: 'Đang vận chuyển', bgColor: 'badge badge-info' },
    { id: 213, text: 'Giữ hàng trong kho', bgColor: 'badge badge-warning' },
    { id: 100, text: 'Chờ duyệt', bgColor: 'badge badge-primary' },
    { id: 200, text: 'Đã duyệt', bgColor: 'badge badge-info' },
    { id: 201, text: 'HVC đang lấy hàng', bgColor: 'badge badge-info' },
    { id: 202, text: 'HVC chưa lấy được hàng', bgColor: 'badge badge-info' },
    { id: 203, text: 'Chờ gửi hàng drop-off', bgColor: 'badge badge-info' },
    { id: 210, text: 'Chờ đóng gói', bgColor: 'badge badge-warning' },
    { id: 211, text: 'Kho sẵn sàng giao hàng', bgColor: 'badge badge-info' },
    { id: 220, text: 'Nhận thông tin đơn hàng', bgColor: 'badge badge-secondary' },
    { id: 230, text: 'Đang xử lý trong kho nước gửi', bgColor: 'badge badge-secondary' },
    { id: 231, text: 'Hàng tới hub nước gửi', bgColor: 'badge badge-secondary' },
    { id: 232, text: 'Hàng rời hub nước gửi', bgColor: 'badge badge-secondary' },
    { id: 233, text: 'Đang vận chuyển quốc tế', bgColor: 'badge badge-secondary' },
    { id: 235, text: 'Đã thông quan', bgColor: 'badge badge-secondary' },
    { id: 234, text: 'Chờ thông quan', bgColor: 'badge badge-secondary' },
    { id: 236, text: 'Đang vận chuyển về hub nước nhận', bgColor: 'badge badge-secondary' },
    { id: 237, text: 'Hàng đã rời hub nước phát', bgColor: 'badge badge-secondary' },
    { id: 300, text: 'Đã lấy hàng', bgColor: 'badge badge-info' },
    { id: 310, text: 'Chờ phát hàng', bgColor: 'badge badge-info' },
    { id: 400, text: 'Phát không thành công', bgColor: 'badge badge-danger' },
    { id: 410, text: 'Chờ xác nhận giao lại', bgColor: 'badge badge-warning' },
    { id: 420, text: 'Sắp chuyển hoàn', bgColor: 'badge badge-warning' },
    { id: 430, text: 'Đã xác nhận chuyển hoàn', bgColor: 'badge badge-warning' },
    { id: 500, text: 'Đang chuyển hoàn', bgColor: 'badge badge-warning' },
    { id: 510, text: 'Phát hoàn không thành công', bgColor: 'badge badge-danger' },
    { id: 511, text: 'Người bán từ chối nhận', bgColor: 'badge badge-danger' },
    { id: 520, text: 'Chờ nhận hàng hoàn ở bưu cục', bgColor: 'badge badge-warning' },
    { id: 530, text: 'Đang hoàn về nước gửi', bgColor: 'badge badge-warning' },
    { id: 610, text: 'Đã hoàn tới hub nước gửi', bgColor: 'badge badge-warning' },
    { id: 600, text: 'Hoàn thành công', bgColor: 'badge badge-warning' },
    { id: 700, text: 'Đơn hủy bởi khách hàng', bgColor: 'badge badge-danger' },
    { id: 701, text: 'Đơn hủy bởi vận hành', bgColor: 'badge badge-danger' },
    { id: 702, text: 'Đơn hủy bởi đối tác', bgColor: 'badge badge-danger' },
    { id: 703, text: 'Đơn hủy bởi hệ thống', bgColor: 'badge badge-danger' },
    { id: 900, text: 'Đã đóng', bgColor: 'badge badge-danger' },
    { id: 704, text: 'Chờ xác thực trạng thái', bgColor: 'badge badge-warning' },
    { id: 605, text: 'Hủy hàng tại nơi phát', bgColor: 'badge badge-warning' },
    { id: 705, text: 'Hủy đơn khi xuất kho', bgColor: 'badge badge-warning' },
    { id: 901, text: 'Đã đối soát', bgColor: 'badge badge-success' },
    { id: 710, text: 'Đơn huỷ, chuyển tiếp về kho', bgColor: 'badge badge-warning' },
    { id: 711, text: 'Đơn huỷ, chuyển tiếp về kho', bgColor: 'badge badge-warning' },
    { id: 229, text: 'Đang vận chuyển nội địa', bgColor: 'badge badge-info' },
    { id: 238, text: 'Đang vận chuyển về hub nước nhận', bgColor: 'badge badge-secondary' },
    { id: 214, text: 'Need to correct address', bgColor: 'badge badge-primary' },
    { id: 501, text: 'Đang chờ nhận hoàn', bgColor: 'badge badge-warning' },
    { id: 204, text: 'Đã in vận đơn', bgColor: 'badge badge-warning' },
    { id: 606, text: 'Hủy tại bưu cục bởi hệ thống', bgColor: 'badge badge-warning' },
    { id: 239, text: 'Đang vận chuyển về hub nước nhận', bgColor: 'badge badge-secondary' },
    { id: 708, text: 'Huỷ do thất lạc', bgColor: 'badge badge-danger' },
    { id: 706, text: 'Chờ hủy tại kho', bgColor: 'badge badge-warning' },
    { id: 110, text: 'Đang chờ label', bgColor: 'badge badge-primary' },
    { id: 801, text: 'Hoàn tất đơn hàng', bgColor: 'badge badge-success' },
    { id: 301, text: 'Đã bàn giao', bgColor: 'badge badge-success' },
    { id: 302, text: 'Hãng từ chối lấy hàng', bgColor: 'badge badge-warning' },
    { id: 502, text: 'Đã nhận tại kho', bgColor: 'badge badge-info' },
    { id: 221, text: 'Chờ xác nhận mất hàng', bgColor: 'badge badge-warning' },
    { id: 504, text: 'Tạm giữ', bgColor: 'badge badge-warning' },
    { id: 215, text: 'HVC đang tìm bưu tá', bgColor: 'badge badge-info' },
    { id: 216, text: 'HVC đã tìm thấy bưu tá', bgColor: 'badge badge-info' },
    { id: 217, text: 'Đang đóng gói', bgColor: 'badge badge-warning' },
    { id: 240, text: 'Đã đóng gói', bgColor: 'badge badge-info' },
    { id: 241, text: 'Chờ dán nhãn', bgColor: 'badge badge-warning' },
    { id: 280, text: 'Chờ bàn giao', bgColor: 'badge badge-info' },
    { id: 503, text: 'Đã kiểm', bgColor: 'badge badge-info' },
    { id: 242, text: 'Đang dán nhãn', bgColor: 'badge badge-info' },
  ],
  reasonTransferWarehouse: [
    { id: 'TRANSFER_ECOMMERCE', text: 'Điều chuyển thiết bị thương mại điện tử' },
    { id: 'TRANSFER_INTERNAL', text: 'Điều chuyển nội bộ' },
    {
      id: 'TRANSFER_SALES_STAFF',
      text: 'Điều chuyển thiết bị cho nhân viên kinh doanh',
    },
    { id: 'TRANSFER_WITHDRAWAL', text: 'Điều chuyển thu hồi' },
    { id: 'TRANSFER_WARRANTY', text: 'Điều chuyển thiết bị bảo hành' },
    { id: 'TRANSFER_USED', text: 'Điều chuyển thiết bị đã qua sử dụng' },
    { id: 'TRANSFER_BROKEN', text: 'Điều chuyển thiết bị hỏng' },
    { id: 'TRANSFER_AGENCY', text: 'Điều chuyển thiết bị đến đại lý' },
    { id: 'TRANSFER_PARTNER', text: 'Điều chuyển vào kho bank' },
    { id: 'TRANSFER_RETURN_FROM_AGENT', text: 'Chuyển hoàn từ đại lý' },
    { id: 'TRANSFER_CHANNEL', text: 'Điều chuyển thiết bị chuyển đổi kênh bán hàng' },
  ],
  reasonExport: [
    { id: 'EXPORT_SELL', text: 'Xuất bán' },
    { id: 'EXPORT_TRANSFER', text: 'Xuất điều chuyển' },
    { id: 'EXPORT_LEND', text: 'Xuất thiết bị cho mượn' },
    {
      id: 'EXPORT_LEND_WARRANTY',
      text: 'Xuất cho mượn trong thời gian bảo hành',
    },
    { id: 'EXPORT_RETURNS', text: 'Xuất thiết bị đổi trả' },
    { id: 'EXPORT_WARRANTY', text: 'Xuất thiết bị đã bảo hành' },
    { id: 'EXPORT_RETURNS_FREE', text: 'Xuất thiết bị đổi trả miễn phí' },
    { id: 'EXPORT_RETURNS_FEE', text: 'Xuất thiết bị đổi trả có phí' },
    { id: 'EXPORT_WARRANTY_SUCCESS', text: 'Xuất thiết bị bảo hành thành công' },
    { id: 'EXPORT_WARRANTY_FAIL', text: 'Xuất thiết bị bảo hành không thành công' },
    { id: 'EXPORT_RENT', text: 'Xuất thiết bị cho thuê' },
    { id: 'EXPORT_BALANCE', text: 'Xuất điều chỉnh số lượng' },
    { id: 'EXPORT_LOSS', text: 'Xuất thiết bị thất lạc' },
    { id: 'EXPORT_SELL_ECOMMERCE', text: 'Xuất bán thương mại' },
    { id: 'EXPORT_CLEAR_SIM', text: 'Xuất sim' },
  ],
  paymentType: [
    { id: 'PAY_NOW', text: 'Mua trả ngay' },
    { id: 'PAY_LATE', text: 'Mua trả chậm' },
  ],
  ownershipTypeData: [
    { id: 'LEND', text: 'Cho mượn' },
    { id: 'PURCHASE', text: 'Mua' },
  ],
  typeTransaction: [
    { id: 'COMMODITY', text: 'Hàng hoá' },
    { id: 'SERVICE', text: 'Dịch vụ' },
    { id: 'CASH_BACK', text: 'Cashback' },
    { id: 'INSTALLMENT', text: 'Trả góp' },
    { id: 'CHARITY', text: 'Từ thiện' },
    { id: 'COMPLAINT', text: 'Khuyến mãi' },
    { id: 'UN_KNOWS', text: 'Không xác định' },
  ],
  typeRisk: [
    { id: 'RULE_FOREIGN_CARD', text: 'Giao dịch thẻ nước ngoài' },
    { id: 'RULE_FOREIGN_CARD_FIRST_TIME', text: 'Giao dịch thẻ nước ngoài' },
    { id: 'RULE_SAMSUNGPAY', text: 'Giao dịch SamSung Pay' },
    {
      id: 'RULE_TRANSACTION_BY_MERCHANT',
      text: 'Giao dịch thực hiện bới Chủ ĐVCNT',
    },
    { id: 'RULE_TIMES_BY_CATEGORY', text: 'Thời gian thanh toán bất thường' },
    { id: 'RULE_TIME_FREQ', text: 'Giao dịch thẻ quẹt liên tiếp' },
    { id: 'RULE_TIME_POSITION', text: 'Thẻ quẹt tại nhiều điểm bất thường' },
    { id: 'RULE_AMOUNT_MAX', text: 'Giao dịch giá trị lớn' },
    {
      id: 'RULE_BLACK_PAN',
      text: 'Giao dịch thuộc danh sách ngân hàng nghi ngờ rủi ro',
    },
    { id: 'RULE_BANK_DELAY', text: 'NH tra soát /xác thực giao dịch' },
    { id: 'RULE_BLACK_LIST', text: 'NH tra soát /xác thực giao dịch' },
    { id: 'RULE_SAME_AMOUNT', text: 'Giao dịch cùng số tiền' },
    { id: 'RULE_WAIT_DOCUMENT', text: 'Giao dịch bị khiếu nại' },
    { id: 'RULE_QR_PENDING', text: 'GD QR, linkcard bất thường' },
    { id: 'RULE_OTA', text: 'Giao dịch Mô tô' },
    { id: 'UN_KNOWS', text: 'UNKNOWS' },
  ],
  transactionStt: [
    { id: 'FAIL_97', text: 'Thất bại' },
    { id: 'PRECESSING_98', text: 'Đang xử lý' },
    { id: 'RETURN_99', text: 'Hoàn trả' },
    { id: 'SUCCESS_100', text: 'Thành công' },
    { id: 'REVERSE_101', text: 'Đảo' },
    { id: 'CANCEL_102', text: 'Hủy' },
    { id: 'WAIT_HOLDER_SIGN_103', text: 'Đang chờ chữ ký chủ thẻ' },
    { id: 'ACCOUNTING_104', text: 'Kết toán' },
    { id: 'WAIT_COMPLETE_105', text: 'Đang chờ hoàn thành' },
    { id: 'PAID_106', text: 'Đã thanh toán' },
    { id: 'UN_KNOWS', text: 'Không xác định' },
  ],
  licenceStt: [
    { id: 'NO_PROVIDE', text: 'Chưa cung cấp' },
    { id: 'WAIT_OP_APPROVE', text: 'Chờ vận hành duyệt' },
    { id: 'WAITE_DIRECTOR_APPROVE', text: 'Chờ GĐV duyệt' },
    { id: 'DIRECTOR_REJECT', text: 'GĐV từ chối' },
    { id: 'REJECT', text: 'Từ chối' },
    { id: 'COMPLETE', text: 'Hoàn thành' },
  ],
  methodT2: [
    { id: 'PHONE_CALL', text: 'Gọi điện' },
    { id: 'MEET_DIRECT', text: 'Gặp trực tiếp' },
    { id: 'TEXT_MESSAGE', text: 'Nhắn tin' },
    { id: 'EMAIL', text: 'Email' },
    { id: 'HOT_LINE', text: 'Hotline' },
  ],
  resultT2: [
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'FAIL', text: 'Thất bại' },
  ],
  refundStatus: [
    { id: 'REFUNDED', text: 'Hoàn tiền' },
    { id: 'NO_REFUND', text: 'Không hoàn tiền' },
  ],
  refundReason: [
    { id: 'SOFTWARE_DEVICE', text: 'Hoàn tiền thiết bị/phần mềm' },
    { id: 'RENT_LEND', text: 'Hoàn tiền cọc cho thuê/cho mượn' },
    {
      id: 'CONTRACT_COINCIDENCE',
      text: 'Hoàn tiền do thanh toán trùng hợp đồng',
    },
  ],
  refundReportStatus: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'WAIT_APPROVE', text: 'Chờ GĐV duyệt' },
    { id: 'CANCELLED', text: 'Đã huỷ' },
    { id: 'APPROVED', text: 'GĐV đã duyệt' },
    { id: 'REJECTED', text: 'GDV từ chối' },
    { id: 'SUCCESS', text: 'Hoàn thành' },
  ],
  statusEmail: [
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'FAIL', text: 'Thất bại' },
    { id: 'PENDING', text: 'Chờ gửi' },
  ],
  typeDiviceReport: [
    { id: 'ALL', text: 'Tổng hợp' },
    { id: 'REGION', text: 'Vùng' },
    { id: 'INVENTORY_ALL', text: 'Kho tổng' },
  ],
  monthConfig: [
    { id: 'JAN', text: 'Tháng 1' },
    { id: 'FEB', text: 'Tháng 2' },
    { id: 'MAR', text: 'Tháng 3' },
    { id: 'APR', text: 'Tháng 4' },
    { id: 'MAY', text: 'Tháng 5' },
    { id: 'JUN', text: 'Tháng 6' },
    { id: 'JUL', text: 'Tháng 7' },
    { id: 'AUG', text: 'Tháng 8' },
    { id: 'SEP', text: 'Tháng 9' },
    { id: 'OCT', text: 'Tháng 10' },
    { id: 'NOV', text: 'Tháng 11' },
    { id: 'DEC', text: 'Tháng 12' },
  ],
  trackingType: [
    { id: 'CHECK_IN', text: 'Checkin' },
    { id: 'CHECK_OUT', text: 'Checkout' },
    { id: 'LOGIN', text: 'Login' },
    { id: 'PERIODIC', text: 'Định kỳ' },
    { id: 'ADDITIONAL_TIMEKEEPING', text: 'Chấm công bổ sung' },
    { id: 'CREATE_LEAD', text: 'Tạo lead' },
    { id: 'CREATE_JOB', text: 'Tạo công việc' },
    { id: 'CONTRACT', text: 'Ký hợp đồng' },
  ],
  stateReceipt: [
    { id: 'NEW', text: 'Mới tạo', bgColor: ' badge-primary' },
    { id: 'PENDING_APPROVAL', text: 'Chờ duyệt', bgColor: ' badge-warning' },
    { id: 'WAIT_SETTLEMENT', text: 'Chờ kết toán', bgColor: ' badge-warning' },
    { id: 'DONE', text: 'Đã thu tiền', bgColor: ' badge-success' },
    { id: 'CANCEL', text: 'Bị huỷ', bgColor: ' badge-danger' },
  ],
  typePayment: [
    { id: 'CUSTOMER_CARD', text: 'Quẹt thẻ khách' },
    { id: 'SALE_CARD', text: 'Quẹt thẻ Sales' },
    { id: 'CUSTOMER_TRANSFER', text: 'Khách chuyển khoản' },
    { id: 'QR_CODE', text: 'Quét mã QR' },
  ],
  refundRecipient: [
    { id: 'REFUND_MERCHANT', text: 'Hoàn tiền về STK merchant' },
    { id: 'REFUND_STAFF', text: 'Hoàn tiền về STK của NVKD' },
  ],
  statusJob: [
    { id: 'APPROVE', text: 'Đã duyệt' },
    { id: 'REJECT', text: 'Từ chối' },
    { id: '', text: 'Chưa duyệt' },
  ],

  statusCskhJob: [
    { id: 'APPROVED', text: 'Đã duyệt', badge: 'primary' },
    { id: 'REJECTED', text: 'Từ chối', badge: 'danger' },
    { id: 'WAIT_APPROVED', text: 'Chưa duyệt', badge: 'warning' },
  ],

  jobPurposes: [
    {
      id: 'ERROR_HANDLING',
      text: 'A- Xử lý lỗi',
    },
    {
      id: 'EXPERTISE',
      text: 'B-Thẩm định',
    },
    {
      id: 'MONITORING',
      text: 'C-Kiểm tra-Giám sát',
    },
    {
      id: 'SUPPORT_LICENCE',
      text: 'D-Hỗ trợ chứng từ',
    },
    {
      id: 'CONSULTING',
      text: 'E-Tư vấn hướng dẫn',
    },
    {
      id: 'HANDOVER_DEVICE',
      text: 'F-Bàn giao thiết bị',
    },
    {
      id: 'SUPPORT_INFO',
      text: 'G-Hỗ trợ thay đổi thông tin',
    },
    {
      id: 'SUPPORT_ONBOARD',
      text: 'H-CS Onboard',
    },
    {
      id: 'SUPPORT_INACTIVE',
      text: 'I-CS Inactive',
    },
    {
      id: 'SUPPORT_ACTIVE',
      text: 'K-CS Active',
    },
    {
      id: 'SUPPORT_KEY',
      text: 'L-CS Key',
    },
    {
      id: 'SUPPORT_DECREASE_TPV',
      text: 'M-CS Giảm TPV',
    },
    {
      id: 'STICKER_PARTNER',
      text: 'N- Dán sticker đối tác',
    },
    {
      id: 'ADD_MC_PHOTOS',
      text: 'O- Bổ sung ảnh ĐKKD, CMND/CCCD, Giấy ủy quyền của MC',
    },
  ],
  jobClassify: [
    {
      id: 'MERCHANT',
      text: 'Công việc với Merchant',
    },
    {
      id: 'LEAD',
      text: 'Công việc chăm sóc Lead',
    },
    {
      id: 'OTHER',
      text: 'Công việc khác',
    },
  ],
  jobTypes: [
    {
      id: 'MC_ONBOARD',
      text: 'CS - MC ONBOARD',
    },
    {
      id: 'MC_INACTIVE',
      text: 'CS - MC INACTIVE',
    },
    {
      id: 'MC_DECREASE_TPV',
      text: 'CS - MC GIẢM TPV',
    },
    {
      id: 'INCIDENT',
      text: 'CS - MC xử lý sự vụ',
    },
    {
      id: 'MC_KEY',
      text: 'CS - MC Key',
    },
    {
      id: 'NORMAL',
      text: 'CS - MC Thường',
    },
    {
      id: 'MC_CS',
      text: 'CS - Hỗ trợ phần mềm',
    },
  ],
  paymentMethods: [
    { id: 'CARD', text: 'Thẻ' },
    { id: 'LINKCARD', text: 'Nhập thẻ' },
    { id: 'QR', text: 'QR code' },
    { id: 'MPOS_BALANCE', text: '"Số dư ví DV' },
    { id: 'UN_KNOWS', text: 'Không xác định' },
  ],
  optionAmounts: [
    { id: '50000-500000', text: 'Từ 50.000đ - 500.000đ' },
    { id: '500000-1000000', text: 'Từ 500.000đ - 1.000.000đ' },
    { id: '1000000-5000000', text: 'Từ 1.000.000đ - 5.000.000đ' },
    { id: '5000000-500000000', text: 'Từ 5.000.000đ - 50.000.0000đ' },
    { id: '50000000-100000000', text: 'Từ 50.000.000đ - 100.000.000đ' },
    { id: '90000000-max', text: 'Trên 90.000.000đ' },
    { id: '100000000-max', text: 'Trên 100.000.000đ' },
  ],
  ticketStatus: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'PROCESSING', text: 'Đang xử lý' },
    { id: 'PENDING', text: 'Tạm hoãn' },
    { id: 'CANCELED', text: 'Đã hủy' },
    { id: 'COMPLETE', text: 'Hoàn thành' },
  ],
  ticketSource: [
    { id: 'MERCHANT', text: 'Merchant' },
    { id: 'AFS_ONLINE', text: 'AFS online' },
    { id: 'AFS_OFFLINE', text: 'AFS offline' },
    { id: 'OPERATION', text: 'Vận hành' },
    { id: 'ACCOUNTANT', text: 'Kế toán' },
  ],
  informMethod: [
    { id: 'CALL', text: 'Gọi điện' },
    { id: 'MESSAGE', text: 'Nhắn tin' },
    { id: 'DIRECT_MEET', text: 'Gặp trực tiếp' },
    { id: 'EMAIL', text: 'Email' },
    { id: 'HOT_MAIL', text: 'Hotline' },
    { id: 'CHECK_NORMAL', text: 'Kiểm tra định kỳ' },
  ],
  informs: [
    { text: 'Gọi điện', id: 'CALL' },
    { text: 'Tin nhắn', id: 'MESSAGE' },
    { text: 'Trò chuyện', id: 'CHAT' },
    { text: 'Kiểm tra merchant', id: 'CHECK' },
    { text: 'Email', id: 'EMAIL' },
    { text: 'Đường dây nóng', id: 'HOT_LINE' },
  ],
  informSources: [
    { text: 'Merchant', id: 'MERCHANT' },
    { text: 'Quản lý', id: 'MANAGER' },
    { text: 'Vận hành', id: 'OPERATOR' },
    { text: 'Sales', id: 'SALES' },
    { text: 'Khác', id: 'OTHER' },
  ],
  paymentOrderStatus: [
    { id: 'WAIT_APPROVE', text: 'Chờ GS duyệt' },
    { id: 'APPROVED', text: 'GS đã duyệt - Chờ chi' },
    { id: 'REJECTED', text: 'Bị từ chối' },
    { id: 'SUCCESS', text: 'Đã chi tiền' },
  ],
  confirmBusinessReg: [
    { id: true, text: 'Đã cam kết' },
    { id: false, text: 'Chưa cam kết' },
  ],
  kpiStatus: [
    { id: 'YES_KPI', text: 'Đã tính KPI' },
    { id: 'NO_KPI', text: 'Chưa tính KPI' },
  ],
  statusExportDevice: [
    { id: 'EXPORTED', text: 'Đã xuất' },
    { id: 'NOT_EXPORTED', text: 'Chưa xuất' },
  ],
  statusHandoverList: [
    { id: 'WAIT_APPROVE', text: 'Chờ duyệt' },
    { id: 'SUCCESS', text: 'Bàn giao thành công' },
    { id: 'UNSENT', text: 'Chưa xác nhận bàn giao' },
    { id: 'SEND', text: 'Đã gửi xác nhận' },
    { id: 'REJECTED', text: 'Từ chối' },
  ],
  typeExportHandoverList: [
    { id: 'CONTRACT', text: 'Hợp đồng' },
    { id: 'ECOMMERCE', text: 'Thương mại điện tử' },
  ],
  statusDeviceKpi: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'WAIT_ACCOUNTANT_APPROVE', text: 'Chờ kế toán duyệt' },
    { id: 'WAIT_MONITOR_APPROVE', text: 'Chờ giám sát duyệt' },
    { id: 'ACCOUNTANT_REJECT', text: 'Kế toán từ chối' },
    { id: 'MONITOR_REJECT', text: 'Giám sát từ chối' },
    { id: 'EXPLANATION', text: 'Cần SA giải trình' },
    { id: 'ADDITIONAL', text: 'Cần SA bổ sung' },
    { id: 'SUCCESS', text: 'Hoàn thành' },
    { id: 'CANCEL', text: 'Đã hủy' },
  ],
  logsDeviceKpi: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'UPDATE', text: 'Chỉnh sửa' },
    { id: 'ACCOUNTANT_REQUEST_ADDITIONAL', text: 'Kế toán yêu cầu bổ sung' },
    { id: 'ACCOUNTANT_APPROVE', text: 'Kế toán xác nhận' },
    { id: 'ACCOUNTANT_REJECT', text: 'Kế toán từ chối' },
    { id: 'SALE_ADMIN_ADDITIONAL', text: 'SA đã bổ sung' },
    { id: 'MONITOR_REQUEST_EXPLANATION', text: 'Giám sát yêu cầu giải trình' },
    { id: 'MONITOR_REJECT', text: 'Giám sát từ chối' },
    { id: 'SALE_ADMIN_EXPLANATION', text: 'SA đã giải trình' },
    { id: 'SUCCESS', text: 'Hoàn thành' },
  ],
  serviceType: [
    { id: 'PAYMENT', text: 'Thanh toán' },
    { id: 'SELL', text: 'Bán hàng' },
  ],
  statusPaymentOptions: [
    { id: 'PAID', text: 'Đã thu tiền' },
    { id: 'UNPAID', text: 'Chưa thu tiền' },
  ],
  statusFileContractOptions: [
    { id: 'RECEIVED', text: 'Đã nhận' },
    { id: 'NOT_RECEIVED', text: 'Chưa nhận' },
  ],
  createdFileBy: [
    { id: 'CREATE_FILE', text: 'Tạo bằng file' },
    { id: 'CREATE_ODD', text: 'Tạo lẻ' },
  ],
  confirmInvoice: [
    { id: 'CONFIRMED', text: 'Đã xác thực' },
    { id: 'UNCONFIRMED', text: 'Chưa xác thực' },
  ],
  getText: (id, options) => {
    const result = id
    const finded = options.find(e => e.id === id)
    if (finded) {
      return finded.text
    }
    return result
  },
  getSearch: data => {
    return [{ id: '0', text: 'Tất cả' }, ...data]
  },
  paymentMethod: [
    { id: 'SDK_MPOS', text: 'Thanh toán bằng SDK MPOS' },
    { id: 'CARD', text: 'Quẹt thẻ không dùng SDK MPOS' },
  ],
  statusCalendarAfs: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'PROCESSING', text: 'Đang xử lý' },
    { id: 'FINISH', text: 'Hoàn thành' },
    { id: 'CANCELED', text: 'Đã hủy' },
  ],
  resultCalendarAfs: [
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'FAILED', text: 'Thất bại' },
    { id: 'OTHERS', text: 'Khác' },
  ],
  updateHandmadeCategoryTicket: [
    { id: 'true', text: 'Có' },
    { id: 'false', text: 'Không' },
  ],
  GPDKKD: [
    { id: 'YES', text: 'Có' },
    { id: 'NO', text: 'Không' },
    { id: 'DOING', text: 'Đang làm' },
  ],
  storeLocation: [
    { id: 'ALLEY', text: 'Hẻm' },
    { id: 'APARTMENT', text: 'Chung cư/Online' },
    { id: 'FACADE', text: 'Mặt tiền lớn' },
  ],
  valueOrder: [
    { id: 'SMALL', text: '300.000đ - 1.000.000đ' },
    { id: 'MEDIUM', text: '1.000.000đ - 5.000.000đ' },
    { id: 'LARGE', text: '5.000.000đ - 10.000.000đ' },
    { id: 'BIG', text: '> 10.000000đ' },
  ],
  averageAgeBuyer: [
    { id: 'YOUNG', text: '15 - 20 tuổi' },
    { id: 'MIDDLE', text: '21 - 40 tuổi' },
    { id: 'OLD', text: '40 tuổi trở lên' },
    { id: 'B2B', text: 'B2B' },
  ],
  knowMPOS: [
    { id: 'POSM', text: 'Thấy POSM' },
    { id: 'SALE', text: 'Sale tư vấn' },
    { id: 'ADS', text: 'Quảng cáo' },
    { id: 'INTRODUCED', text: 'Được giới thiệu' },
  ],
  ownPOS: [
    { id: 'YES', text: 'Có POS' },
    { id: 'NO', text: 'Chưa có POS' },
    { id: 'USING', text: 'Đang dùng MPOS' },
    { id: 'REVOKED', text: 'Có POS nhưng bị thu hồi' },
  ],
  rating: [
    { id: 'HOT', text: 'Ưu tiên' },
    { id: 'WARM', text: 'Thường' },
    { id: 'COLD', text: 'Không ưu tiên' },
  ],
  customerType: [
    { id: 'COMPANY', text: 'Doanh nghiệp' },
    { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
    { id: 'INDIVIDUAL', text: 'Cá nhân' },
  ],
  tagLead: [
    { id: 'NON_POTENTIAL', text: 'Tiềm năng thấp' },
    { id: 'POTENTIAL', text: 'Tiềm năng' },
    { id: 'VERY_POTENTIAL', text: 'Tiềm năng cao' },
  ],
  invoiceSate: [
    { id: 'DONE', text: 'Đã tạo hóa đơn' },
    { id: 'CANCEL', text: 'Đã hủy hóa đơn' },
    { id: 'NEW', text: 'Chưa xuất hóa đơn' },
  ],
  warrantyStatus: [
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'UNSUCCESSFUL', text: 'Chưa thành công' },
  ],
  faultMaker: [
    { id: 'PRODUCER', text: 'Nhà sản xuất' },
    { id: 'USER', text: 'Người dùng' },
    { id: 'OTHER', text: 'Chưa xác định' },
  ],
  errorTypeDevice: [
    { id: 'ERROR', text: 'Bị lỗi' },
    { id: 'BROKEN_PART', text: 'Bị hỏng 1 phần' },
    { id: 'BROKEN_ALL', text: 'Bị hỏng hoàn toàn' },
  ],
  actionContract: {
    OTP: 'OTP',
    APPROVE_UPDATE_CUS: 'APPROVE_UPDATE_CUS',
    REQUEST_ADDITIONAL: 'REQUEST_ADDITIONAL',
    APPROVE_COLLARBORATOR: 'APPROVE_COLLARBORATOR',
    REJECT_COLLARBORATOR: 'REJECT_COLLARBORATOR',
    REJECT_SA: 'REJECT_SA',
    APPROVE_REJECT: 'APPROVE_REJECT',
    MPOS_REJECT: 'MPOS_REJECT',
    APPROVE_REJECT_LIQUID: 'APPROVE_REJECT_LIQUID',
    APPROVE_REJECT_FEE: 'APPROVE_REJECT_FEE',
    WAITING_APPROVE: 'WAITING_APPROVE',
    RE_CREATE_RECEIPT: 'RE_CREATE_RECEIPT',
    SYNC_MPOS: 'SYNC_MPOS',
    SEND_EMAIL: 'SEND_EMAIL',
    EXPERTISE: 'EXPERTISE',
    ASSIGN_SALE: 'ASSIGN_SALE',
    CREATE_APPENDIX_VISA: 'CREATE_APPENDIX_VISA',
    EDIT_DEVICE: 'EDIT_DEVICE',
    VIEW_APPENDIX: 'VIEW_APPENDIX',
    REMOVE_DEVICE: 'REMOVE_DEVICE',
    REJECT_VISA: 'REJECT_VISA',
    HANOVER_APPROVE_REJECT: 'HANOVER_APPROVE_REJECT',
    HANOVER_APPROVE_REJECT_NEW: 'HANOVER_APPROVE_REJECT_NEW',
    MULTI_FUNCTIONAL_APPROVE_REJECT: 'MULTI_FUNCTIONAL_APPROVE_REJECT',
    CONFIRM_INFO_APPENDIX: 'CONFIRM_INFO_APPENDIX',
    REQUEST_ADDITIONAL_INFO: 'REQUEST_ADDITIONAL_INFO',
    UPDATE_MERCHANT_KEY_TO_NORMAL: 'UPDATE_MERCHANT_KEY_TO_NORMAL',
    UPDATE_MERCHANT_KEY_TO_MCKEY: 'UPDATE_MERCHANT_KEY_TO_MCKEY',
    REQUEST_ADDITIONAL_OPTION: 'REQUEST_ADDITIONAL_OPTION',
    ADD_VIETQR_FEE_330: 'ADD_VIETQR_FEE_330',
    ADD_VIETQR_FEE_550: 'ADD_VIETQR_FEE_550',
    REMOVE_VIETQR_FEE_330: 'REMOVE_VIETQR_FEE_330',
    REMOVE_VIETQR_FEE_550: 'REMOVE_VIETQR_FEE_550',
    HAVE_DKKD: 'HAVE_DKKD',
    MC_OLD_NEW: 'MC_OLD_NEW',
    WAITING_APPROVE_TWO: 'WAITING_APPROVE_TWO',
    CHANGE_FILE_APPENDIX_MPOS: 'CHANGE_FILE_APPENDIX_MPOS',
    RESERVE_CONTRACT: 'RESERVE_CONTRACT',
  },
  levelPotential: [
    { id: 'NON_POTENTIAL', text: 'Tiềm năng thấp' },
    { id: 'POTENTIAL', text: 'Tiềm năng' },
    { id: 'VERY_POTENTIAL', text: 'Tiềm năng cao' },
  ],
  statusCurrentState: [
    { id: 'ACTIVE', text: 'Hoạt động' },
    { id: 'UN_ACTIVE', text: 'Đã khoá' },
  ],
  statusWarranty: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'APPROVED', text: 'Đã duyệt' },
    { id: 'REJECTED', text: 'Từ chối duyệt' },
    { id: 'WAIT_APPROVE', text: 'Chờ duyệt' },
    { id: 'WAIT_RECEIVE', text: 'Chờ tiếp nhận' },
    { id: 'WAIT_PROGRESS', text: 'Chờ xử lý' },
    { id: 'IN_PROGRESS', text: 'Đang xử lý' },
    { id: 'REJECT_IMPORT', text: 'Từ chối' },
    { id: 'SUCCESS', text: 'Hoàn thành' },
    { id: 'CANCELLED', text: 'Đã huỷ' },
  ],
  checkSerial: [
    { id: 'NORMAL', text: 'Không' },
    { id: 'SERIAL', text: 'Có' },
  ],
  mposStt: [
    { id: 'NOT_CONFIGURED', text: 'Chưa cấu hình' },
    { id: 'PROCESSING', text: 'Đang xử lý' },
    { id: 'CONFIGURED', text: 'Đã cấu hình' },
    { id: 'REJECT', text: 'Từ chối' },
    { id: 'DENIED', text: 'Hệ thống từ chối' },
    { id: 'PENDING', text: 'Chờ duyệt đổi' },
    { id: 'APPROVED', text: 'Duyệt đổi trả' },
  ],
  mposSttConfigGured: [
    { id: 'CONFIRM', text: 'MC đã xác nhận', bgColor: 'badge badge-success' },
    { id: 'SUCCESS', text: 'Kích hoạt thành công', bgColor: 'badge badge-success' },
    { id: 'FAIL', text: 'Kích hoạt lỗi', bgColor: 'badge badge-danger' },
    { id: 'DENIED', text: 'VH từ chối', bgColor: 'badge badge-danger' },
    { id: 'PENDING', text: 'Mới tạo', bgColor: 'badge badge-primary' },
    { id: 'APPROVED', text: 'VH đã duyệt', bgColor: 'badge badge-success' },
  ],
  GPDKKD: [
    { id: 'YES', text: 'Có' },
    { id: 'NO', text: 'Không' },
    { id: 'DOING', text: 'Đang làm' },
  ],
  storeLocation: [
    { id: 'ALLEY', text: 'Hẻm' },
    { id: 'APARTMENT', text: 'Chung cư/Online' },
    { id: 'FACADE', text: 'Mặt tiền lớn' },
  ],
  valueOrder: [
    { id: 'SMALL', text: '300.000đ - 1.000.000đ' },
    { id: 'MEDIUM', text: '1.000.000đ - 5.000.000đ' },
    { id: 'LARGE', text: '5.000.000đ - 10.000.000đ' },
    { id: 'BIG', text: '> 10.000000đ' },
  ],
  averageAgeBuyer: [
    { id: 'YOUNG', text: '15 - 20 tuổi' },
    { id: 'MIDDLE', text: '21 - 40 tuổi' },
    { id: 'OLD', text: '40 tuổi trở lên' },
    { id: 'B2B', text: 'B2B' },
  ],
  knowMPOS: [
    { id: 'POSM', text: 'Thấy POSM' },
    { id: 'SALE', text: 'Sale tư vấn' },
    { id: 'ADS', text: 'Quảng cáo' },
    { id: 'INTRODUCED', text: 'Được giới thiệu' },
  ],
  ownPOS: [
    { id: 'YES', text: 'Có POS' },
    { id: 'NO', text: 'Chưa có POS' },
    { id: 'USING', text: 'Đang dùng MPOS' },
    { id: 'REVOKED', text: 'Có POS nhưng bị thu hồi' },
  ],
  rating: [
    { id: 'HOT', text: 'Ưu tiên' },
    { id: 'WARM', text: 'Thường' },
    { id: 'COLD', text: 'Không ưu tiên' },
  ],
  customerType: [
    { id: 'COMPANY', text: 'Doanh nghiệp' },
    { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
    { id: 'INDIVIDUAL', text: 'Cá nhân' },
  ],
  tagLead: [
    { id: 'NON_POTENTIAL', text: 'Tiềm năng thấp' },
    { id: 'POTENTIAL', text: 'Tiềm năng' },
    { id: 'VERY_POTENTIAL', text: 'Tiềm năng cao' },
  ],
  checkSerial: [
    { id: 'NORMAL', text: 'Không' },
    { id: 'SERIAL', text: 'Có' },
  ],
  statusFileImport: [
    { id: 'NEW', text: 'Mới tạo' },
    { id: 'PROCESSING', text: 'Đang xử lý' },
    { id: 'SUCCESS', text: 'Thành công' },
    { id: 'FAIL', text: 'Lỗi' },
    { id: 'COMPLETED', text: 'Thành công' },
    { id: 'FALSE', text: 'Thất bại' },
  ],
  dataWorkAS: [
    { id: 'ONBOARD_MERCHANT', text: 'Chăm sóc merchant onboard' },
    { id: 'CCCT', text: 'Cung cấp chứng từ giao dịch' },
    { id: 'DENY_INSTALLMENT', text: 'Hỗ trợ xử lý GD trả góp' },
    { id: 'UPDATE_INFO', text: 'Thay đổi thông tin MC' },
    { id: 'CCCT_BANK_SCAN', text: 'Cung cấp chứng từ bank tra soát' },
    { id: 'SALE_CARE_BOXME', text: 'Sale chăm sóc đơn hàng boxme' },

    { id: 'OTHER', text: 'Khác' },
  ],
  verifyOptions: [
    { id: 'VERIFIED', text: 'Xác thực' },
    { id: 'UNVERIFIED', text: 'Chưa xác thực' },
  ],
  deviceLocationStatus: [
    { id: 'ACTIVE', text: 'Hoạt động' },
    { id: 'SUSPENDED', text: 'Khoá' },
  ],
  deviceLocationAppendixType: [
    { id: 'DEVICE', text: 'PL bán thường' },
    { id: 'CASHBACK', text: 'PL bán cashback' },
    { id: 'RENT', text: 'PL cho thuê' },
    { id: 'LEND', text: 'PL cho mượn' },
    { id: 'HAND_OVER_DEVICE_LEND', text: 'BB bàn giao - mượn tạm' },
    {
      id: 'HAND_OVER_DEVICE_RETURNS_FREE',
      text: 'BB bàn giao - đổi thiết bị miễn phí',
    },
    {
      id: 'HAND_OVER_DEVICE_RETURNS_FEE',
      text: 'BB bàn giao - đổi thiết bị có phí',
    },
    {
      id: 'HAND_OVER_DEVICE_WARRANTY_SUCCESS',
      text: 'BB bàn giao - trả thiết bị sửa thành công',
    },
    {
      id: 'HAND_OVER_DEVICE_WARRANTY_FAIL',
      text: 'BB bàn giao - trả thiết bị sửa thất bại',
    },
  ],
  deviceLocationHistoryAction: [
    { id: 'LAP_PL_BB', text: 'Lập PL/BB' },
    { id: 'TAO_MOI', text: 'Tạo mới' },
    { id: 'SUA_TT_THIET_BI', text: 'Sửa TT thiết bị' },
    { id: 'DOI_MC', text: 'Đổi MC' },
    { id: 'DOI_DCNTT', text: 'Đổi ĐCNTT' },
    { id: 'KHOA', text: 'Khóa' },
    { id: 'MO_KHOA', text: 'Mở khóa' },
    { id: 'XAC_THUC', text: 'Xác thực' },
    { id: 'BO_XAC_THUC', text: 'Bỏ xác thực' },
  ],
  onboardPlan: [
    { id: 'ONLINE', text: 'Chăm sóc online' },
    { id: 'OFFLINE', text: 'Chăm sóc offline' },
    { id: 'ONLINE_TO_OFFLINE', text: 'Chăm sóc online -> offline' },
    { id: 'BOTH_ONLINE_OFFLINE', text: 'Chăm sóc cả online và offline' },
  ],
  urgent: [
    { id: 'NORMAL', text: 'Bình thường' },
    { id: 'VERY_URGENT', text: 'Rất gấp' },
    { id: 'URGENT', text: 'Gấp' },
  ],
  mposState: [
    { id: 'ACTIVE', text: 'Hoạt động' },
    { id: 'PENDING_INFORMATION', text: 'Chưa thiết lập thông tin' },
    { id: 'PENDING_APPROVAL', text: 'Chờ MPOS thẩm định' },
    { id: 'PENDING_CONFIRM_APPROVAL', text: 'Chờ Bank thẩm định' },
    { id: 'DENIED', text: 'Bị từ chối' },
    { id: 'SUSPENDED', text: 'Đang khóa' },
  ],
  mcKeyLvl: [
    {
      id: 'MC_NORMAL',
      text: 'MC thường',
    },
    {
      id: 'MC_KEY',
      text: 'MC key',
    },
  ],
  mcKeyOwnerType: [
    {
      id: 'MC_OWNER',
      text: 'Chính chủ',
    },
    {
      id: 'MC_FRANCHISE',
      text: 'Nhượng quyền',
    },
  ],
  mcBankAccType: [
    {
      id: 'MC_COMPANY',
      text: 'Tổ chức',
    },
    {
      id: 'MC_INDIVIDUAL',
      text: 'Cá nhân',
    },
  ],
  statusWkcldr: [
    {
      id: 'PROCESSED',
      text: 'Đã xử lý',
    },
    {
      id: 'NOT_PROCESS',
      text: 'Chưa xử lý',
    },
    {
      id: 'DELETED',
      text: 'Đã huỷ',
    },
  ],
  typeReportInventory: [
    {
      id: 'IMPORT',
      text: 'Nhập',
    },
    {
      id: 'EXPORT',
      text: 'Xuất',
    },
    {
      id: 'ALL',
      text: 'Tổng hợp',
    },
  ],
  finDocStt: [
    {
      id: 'NONE',
      text: 'Không có',
    },
    {
      id: 'FROM_PRINTER',
      text: 'In từ máy',
    },
    {
      id: 'HAND_WRITING',
      text: 'Viết tay',
    },
    {
      id: 'BOTH_PRINTER_HAND_WRITING',
      text: 'Cả in máy và viết tay',
    },
  ],
  statusDeterminedMpos: [
    {
      id: 'EXPERTISE_COLLABORATOR',
      text: 'Đã thẩm định',
    },
    {
      id: 'UNDETERMINED',
      text: 'Chưa thẩm định',
    },
  ],
  optionType: [
    {
      id: 'ODD',
      text: 'Lẻ',
    },
    {
      id: 'TOTAL',
      text: 'Tổng',
    },
    {
      id: 'RATIO',
      text: 'Tỷ lệ',
    },
    {
      id: 'RENT_SELL',
      text: 'Thuê bán',
    },
  ],
  reasonUsageChange: [
    {
      id: 'CHANGE_TO_TEST',
      text: 'Đánh dấu thiết bị test',
    },
    {
      id: 'CHANGE_TO_AVAILABILITY',
      text: 'Đánh dấu thiết bị khả dụng',
    },
  ],
  typeUsage: [
    {
      id: 'SELL',
      text: 'Thiết bị khả dụng',
    },
    {
      id: 'TEST',
      text: 'Thiết bị test',
    },
  ],
  optionStatusCombo: [
    { id: '0', text: 'Tất cả', variant: '', bgColor: '' },
    { id: 'NEW', text: 'Mới tạo', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'CANCELED', text: 'Đã hủy', variant: 'secondary', bgColor: 'badge-secondary' },
    { id: 'PENDING', text: 'Chờ xử lý', variant: 'warning', bgColor: 'badge-warning' },
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'APPROVED', text: 'Đã duyệt', variant: 'success', bgColor: 'badge-success' },
    { id: 'REQUIRED', text: 'Cần bổ sung', variant: 'warning', bgColor: 'badge-warning' },
    { id: 'SUPPLEMENTED', text: 'Đã bổ sung', variant: 'info', bgColor: 'badge-info' },
    { id: 'REJECTED', text: 'Từ chối', bgColor: 'badge-danger' },
  ],
  reserveStatusOptions: [
    { id: 'NOT_RESERVED', text: 'Không bảo lưu' },
    { id: 'RESERVED', text: 'Đang bảo lưu' },
    { id: 'CONTINUE', text: 'Tiếp tục sử dụng' },
  ],
  digitalSignatureRegistrationStatus: [
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'COMPLETED', text: 'Hoàn thành', variant: 'secondary', bgColor: 'badge-success' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'warning', bgColor: 'badge-danger' },
  ],
  taxAuthorityVerifyStatus: [
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'COMPLETED', text: 'Hoàn thành', variant: 'secondary', bgColor: 'badge-success' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'warning', bgColor: 'badge-danger' },
  ],
  optionPaymentStatusCombo: [
    { id: '0', text: 'Tất cả', variant: '', bgColor: '' },
    { id: 'PAID', text: 'Đã thanh toán', variant: 'success', bgColor: 'badge-success' },
    { id: 'UNPAID', text: 'Chưa thanh toán', variant: 'danger', bgColor: 'badge-danger' },
  ],
  listDKKDstateV2: [
    { id: true, text: 'Có' },
    { id: false, text: 'Không' },
  ],
  typeContractPackage: [
    {
      id: 'ONLY_SOFTWARE',
      text: 'Chỉ có PM',
    },
    {
      id: 'SOFTWARE_HARDWARE',
      text: 'PM + Phần cứng (D3/PAL/PAC)',
    },
    {
      id: 'BASIC',
      text: 'Cơ bản',
    },
    {
      id: 'PROFESSIONAL',
      text: 'Chuyên nghiệp',
    },
    {
      id: 'PREMIUM',
      text: 'Cao cấp',
    },
  ],
  appraisalStatus: [
    { id: 'UNDETERMINED ', text: 'Chưa thẩm định' },
    { id: 'EXPERTISE_COLLABORATOR', text: 'Đã thẩm định' },
  ],
  saveStatus: [
    { id: 'ADMIN_RECEIVE', text: 'Sale Admin đã nhận bản giấy' },
    { id: 'ACCOUNTANT_RECEIVE', text: 'Kế toán đã nhận bản giấy' },
    { id: 'ACCOUNTANT_UNRECEIVED', text: 'Kế toán chưa nhận bản giấy' },
    { id: 'SENT_ACCOUNTANT_CONFIRM', text: 'Chờ kế toán xác nhận' },
  ],
  reasonCode: [
    { id: 'B-HLTHE', text: 'Chưa thẩm định' },
    { id: 'EXPERTISE_COLLABORATOR', text: 'Đã thẩm định' },
  ],
  treatmentMethodOption: [
    { id: 'ONTINUE_REPAIRING_THE_DEVICE', text: 'Tiếp tục sửa thiết bị' },
    { id: 'EXCHANGE_DEVICE_FOR_FREE', text: 'Không sửa được, cho đổi miễn phí' },
    { id: 'EXCHANGE_DEVICE_WITH_FEE', text: 'Không sửa được, cho đổi mất phí' },
    { id: 'DEVICE_CANNOT_BE_EXCHANGED', text: 'Không sửa được, không cho đổi thiết bị' },
  ],
  exchangeStatusOption: [
    { id: 'REQUEST_WARRANTY_FEEDBACK', text: 'Xin ý kiến bảo hành tổng' },
    { id: 'WARRANTY_FEEDBACK_PROVIDED', text: 'Bảo hành tổng cho ý kiến' },
  ],
  statusMcBIDV: [
    { id: 'NEW', text: 'Chưa đối soát' },
    { id: 'PROCESSING', text: 'Đã đối soát,từ chối chi' },
    { id: 'SUCCESS', text: 'Đã đối soát, chi tiền' },
  ],

  typePurposeOption: [
    { id: 'NORMAL', text: 'Công việc thường' },
    { id: 'NOTICE_CAMPAIGN', text: 'Thông báo chiến dịch' },
  ],

  // management-sim page
  listOptionStatus: Object.freeze([
    {
      id: 'ACTIVE',
      text: 'Đang hoạt động',
      variant: 'success',
    },
    {
      id: 'EXPIRED',
      text: 'Đã hết hạn',
      variant: 'danger',
    },
    {
      id: 'DISABLE',
      text: 'Đã vô hiệu hóa',
      variant: 'danger',
    },
    {
      id: 'PAID_WAITING_RENEWAL',
      text: 'Đã thanh toán, chờ gia hạn',
      variant: 'info',
    },
    {
      id: 'RENEW_FAIL',
      text: 'Gia hạn không thành công',
      variant: 'danger',
    },
    {
      id: 'EXPIRING_SOON',
      text: 'Sắp hết hạn',
      variant: 'danger',
    },
  ]),
  listOptionSupplierSim: Object.freeze({
    SIMVIETTEL: 'VIETTEL',
    SIMMOBI: 'MOBIFONE',
    SIMSKY: 'VNSKY',
  }),
  mposApprovalStatus: Object.freeze([
    { id: 'MPOS_PENDING', text: 'Chờ duyệt' },
    { id: 'MPOS_ACTIVE', text: 'Đã duyệt' },
    { id: 'MPOS_DENIED', text: 'Bị từ chối' },
  ]),

  // sim

  listOptionSupplier: [
    { id: 'VIETTEL', text: 'SIMVIETTEL' },
    { id: 'MOBIFONE', text: 'SIMMOBI' },
    { id: 'VNSKY', text: 'SIMSKY' },
  ],

  listOptionSource: [
    { id: 'Nextpay', text: 'Nextpay' },
    { id: 'other', text: 'Không thuộc nextpay' },
  ],

  listOptionAuthenStatusFilter: [
    { id: 'VERIFIED', text: 'Đã xác thực', bgColor: 'success' },
    { id: 'UNVERIFIED', text: 'Chưa có thông tin', bgColor: 'primary' },
    { id: 'PENDING', text: 'Cần xác minh lại', bgColor: 'warning' },
  ],

  simStatus: [
    { id: 'ACTIVE', text: 'Đang hoạt động', bgColor: 'success' },
    { id: 'EXPIRED', text: 'Đã hết hạn', bgColor: 'danger' },
    { id: 'DISABLE', text: 'Đã vô hiệu hóa', bgColor: 'danger' },
    { id: 'PAID_WAITING_RENEWAL', text: 'Đã thanh toán, chờ gia hạn,', bgColor: 'success' },
    { id: 'RENEW_FAIL', text: 'Gia hạn thất bại', bgColor: 'danger' },
    { id: 'EXPIRING_SOON', text: 'Sắp hết hạn', bgColor: 'warning' },
  ],

  //management-shipping
  ShippingStatus: Object.freeze([
    { id: 'NEW', text: 'Mới tạo', variant: 'primary' },
    { id: 'DELIVERED', text: 'Giao hàng thành công', variant: 'success' },
    { id: 'IN_TRANSIT', text: 'Đang vận chuyển', variant: 'warning' },
    { id: 'FAILED', text: 'Giao hàng thất bại', variant: 'danger' },
  ]),
  ShippingApprovedSatus: Object.freeze([
    { id: 'PENDING', text: 'Chờ duyệt', variant: 'warning' },
    { id: 'APPROVED', text: 'Đã duyệt', variant: 'success' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'danger' },
  ]),
  listCarrierName: Object.freeze([
    { id: 'VIETTEL', text: 'ViettelPost' },
    { id: 'NETPOST', text: 'NetPost' },
    { id: 'NEWPOST', text: 'NewPost' },
  ]),

  //management-lend-device
  receiptStatus: Object.freeze([
    { id: 'UNPAID', text: 'Chưa thu tiền', variant: 'primary' },
    { id: 'DONE', text: 'Đã thu tiền', variant: 'success' },
    { id: 'CANCELLED', text: 'Đã hủy', variant: 'danger' },
  ]),

  additionalReceiptStatus: Object.freeze([
    { id: 'NEW', text: 'Chưa thu tiền', variant: 'primary' },
    { id: 'DONE', text: 'Đã thu tiền', variant: 'success' },
    { id: 'CANCELLED', text: 'Đã hủy', variant: 'danger' },
  ]),

  statusIDLend: Object.freeze([
    { id: 'ACTIVE', text: 'Đang cho mượn', variant: 'success' },
    { id: 'WARNING', text: 'Cảnh báo', variant: 'warning' },
    { id: 'RECALL_REQUESTED', text: 'Yêu cầu thu hồi', variant: 'danger' },
    { id: 'EXTENDED', text: 'Đã gia hạn', variant: 'info' },
    { id: 'RETURNED', text: 'Đã trả', variant: 'secondary' },
    { id: 'CANCELLED', text: 'Đã hủy', variant: 'danger' },
    { id: 'NOT_ACTIVE', text: 'Chưa kích hoạt', variant: 'secondary' },
  ]),

  statusReceipts: Object.freeze([
    { id: 'NEW', text: 'Mới tạo', variant: 'primary' },
    { id: 'CANCELLED', text: 'Đã hủy', variant: 'danger' },
    { id: 'REJECTED', text: 'Bị từ chối', variant: 'danger' },
    { id: 'SUCCESS', text: 'Hoàn thành', variant: 'success' },
  ]),

  statusRefund: Object.freeze([
    { id: 'NEW', text: 'Mới tạo', variant: 'primary' },
    { id: 'CANCELLED', text: 'Đã hủy', variant: 'danger' },
    { id: 'REJECTED', text: 'Bị từ chối', variant: 'danger' },
    { id: 'SUCCESS', text: 'Hoàn thành', variant: 'success' },
  ]),

  statusTpv: Object.freeze([
    { id: 'PASSED', text: 'Đạt', variant: 'success' },
    { id: 'FAILED', text: 'Không đạt', variant: 'danger' },
    { id: 'SKIPPED_DISPLAYED', text: 'Không tính', variant: 'secondary' },
  ]),

  listActionType: Object.freeze([
    { id: 'CREATE', text: 'Tạo mới' },
    { id: 'RECALL_REQUEST', text: 'Yêu cầu thu hồi' },
    { id: 'DEVICE_CHANGE', text: 'Đổi thiết bị' },
    { id: 'EXTEND_REQUEST', text: 'Xin gia hạn thêm' },
    { id: 'RETURN', text: 'Trả thiết bị' },
    { id: 'STATUS_CHANGE', text: 'Thay đổi trạng thái' },
    { id: 'DEPOSIT_COLLECTED', text: 'Thu cọc' },
    { id: 'REFUND_PROCESSED', text: 'Hoàn cọc' },
    { id: 'ADDITIONAL_COLLECTION', text: 'Thu thêm' },
    { id: 'TPV_UPDATE', text: 'Cập nhật TPV' },
    { id: 'EVALUATION_ACTION', text: 'Hành động đánh giá' },
    { id: 'UPDATE_CONTRACT', text: 'Thay đổi thông tin hợp đồng' },
    { id: 'UPDATE_RECEIPT', text: 'Thay đổi thông tin phiếu thu' },
    { id: 'UPDATE_REFUND', text: 'Thay đổi thông tin phiếu hoàn tiền' },
    { id: 'UPDATE_ADDITIONAL_RECEIPT', text: 'Thay đổi thông tin phiếu thu thêm' },
  ]),

  // Trạng thái thay đổi thông tin trên MNP
  statusChangeInfo: Object.freeze([
    { id: 'NEW', text: 'Mới tạo', variant: 'primary' },
    { id: 'SIGNING', text: 'Đang ký', variant: 'warning' },
    { id: 'SIGNED_WAITING_APPROVED', text: 'Đã ký - Chờ duyệt', variant: 'info' },
    { id: 'ADDITIONAL', text: 'Cần bổ sung', variant: 'warning' },
    { id: 'WAITING_SUPPORT', text: 'Chờ hỗ trợ', variant: 'warning' },
    { id: 'CANCELED', text: 'Đã hủy', variant: 'danger' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'danger' },
    { id: 'COMPLETE', text: 'Hoàn thành', variant: 'success' },
  ]),

  // Trạng thái duyệt trên Mpos
  statusApproveMpos: Object.freeze([
    { id: 'MPOS_PENDING', text: 'Chờ duyệt', variant: 'warning' },
    { id: 'MPOS_ACTIVE', text: 'Đã duyệt', variant: 'success' },
    { id: 'MPOS_DENIED', text: 'Từ chối', variant: 'danger' },
  ]),
}
